import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Reaction document interface
 */
export interface ReactionDocument extends BaseDocument {
  entityType: string
  entityId: string
  emoji: string
  emojiLabel: string | null
  emojiShortcode: string | null
  userId: string
  userName: string | null
  userEmail: string | null
}

/**
 * Reaction-specific hooks
 */
const hooks = createEntityHooks<ReactionDocument>('reactions')

export const useReactions = (filter?: Partial<ReactionDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { reactions: data, isLoading, db }
}

export const useReaction = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { reaction: data, isLoading }
}

export const useReactionMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createReaction: create,
    updateReaction: update,
    deleteReaction: deleteEntity,
  }
}
